import React from "react";

// Components
import ListBuyer from "components/organism/buyer-match/list-buyer";
import DetailBuyer from "components/organism/buyer-match/detail-buyer";

// Assets
import IOne21 from "assets/one21.png";

// Ctx
import { BuyerMatchProvider, useBuyerMatchCtx } from "contexts/buyer-match";
import { useGlobalCtx } from "contexts/GlobalContext";

const BuyerMatch = () => {
  const { isOpenDetailBuyer } = useBuyerMatchCtx();
  const { profile } = useGlobalCtx();
  return (
    <div className="wrapper nav-content-wrapper bg-[#E6E7E8]">
      <div className="px-6 py-[14px] bg-white">
        <h1 className="text-[22px] font-inter text-[#252526] font-medium">
          Buyer Match
        </h1>
        <div className="w-[310px] h-[1px] bg-[linear-gradient(90deg,#D8D8D9_0%,#FFF_100%)]" />
        <p className="text-[13px] font-inter text-[#808285]">
          Kelola profil customer dan temukan listing yang paling sesuai dengan
          preferensi mereka secara otomatis.
        </p>
      </div>
      <div className="p-6">
        {isOpenDetailBuyer ? <DetailBuyer /> : <ListBuyer />}
      </div>

      <div className="flex items-center justify-between px-6 py-[14px] border-t border-solid border-[#D8D8D9]">
        <p className="text-[13px] tracker-[-0.4px] leading-[21.034px] font-inter text-[#252526]">
          CENTURY 21 {profile?.company?.name} <span className="text-[#808285]">© 2026.</span>
        </p>

        <div className="flex items-center gap-1">
          <p className="text-[13px] tracker-[-0.4px] leading-[21.034px] font-inter text-[#808285]">
            Powered by
          </p>
          <img
            className="w-[43.922px] h-[43.922px] object-contain"
            src={IOne21}
            alt="one21"
          />
        </div>
      </div>
    </div>
  );
};

const Wrapper = () => {
  return (
    <BuyerMatchProvider>
      <BuyerMatch />
    </BuyerMatchProvider>
  );
};

export default Wrapper;
